module.exports = __webpack_public_path__ + "static/media/Apollo Doctor Partner Logo-01.016013b5.png";